<button
  type="button"
  class="icon-action-button"
  [title]="ariaLabel()"
  [class.neutral]="type() === 'neutral'"
  [class.action]="type() === 'action'"
  [class.delete]="type() === 'delete'"
  [class.custom-fill]="customFill()"
  [class.disabled]="disabled()"
  [attr.aria-label]="ariaLabel()"
  [attr.disabled]="disabled() ? true : null"
  (click)="handleClick($event)"
  (keydown.enter)="handleKeydown($event)"
  (keydown.space)="handleKeydown($event)"
>
  @if (iconConfig(); as config) {
    <icon-induxtry [icon]="config" />
  }
</button>
